import React, { useState } from "react";
import * as styles from "./style.mod.scss";
import { Modal } from "react-bootstrap";
import locale from "locales";
import ScalapayIcon from "assets/svgs/scalapay.svg";
import PinkScalapay from "assets/svgs/scala.svg";
import BlackScalapay from "assets/svgs/scalaB.svg";

const Scalapay = ({ total, scalapaySettings }) => {
  if(!scalapaySettings) return<></>;

  const [open, setOpen] = useState(false);
  const offerCalc = (total / 3).toFixed(2);
  const showModal = () => setOpen(true);
  const hideModal = () => setOpen(false);
  const modalLoc = locale.scalapayModal;
    
  return (
    <div id="scalapay" className={styles.scalapay}>
      <span> {modalLoc.firstDesc} <b> {offerCalc}€ </b> {modalLoc.secondDesc}<a className={styles.scalapayIcons} onClick={showModal}>
        <BlackScalapay /><span>ⓘ</span></a></span>
      <Modal show={open} onHide={hideModal} className={styles.scalapayModal}>
        <div className={styles.scalapayContainer} >
          <div className={styles.scalapayIcon}>
            <ScalapayIcon />
            <a onClick={hideModal}><div className={styles.close}></div></a>
          </div>
          <h2 className={styles.scalapayTitle}>{modalLoc.title}</h2>
          <PinkScalapay />
          <div className={styles.container}>
            <h3 className={styles.scalapaySubtitle}>{modalLoc.subtitle}</h3>
            <p className={styles.scalapayDescription}>{modalLoc.description}</p>
          </div>
          <div className={styles.container}>
            <h3 className={styles.scalapaySubtitle}>{modalLoc.secondSubtitle}</h3>
            <p className={styles.scalapayDescription}>{modalLoc.secondDescription}</p>
          </div>
          <div className={styles.container}>
            <h3 className={styles.scalapaySubtitle}>{modalLoc.thirdSubtitle}</h3>
            <p className={styles.scalapayDescription}>{modalLoc.thirdDescription}</p>
          </div>
          <p className={styles.visitScalapay}>{modalLoc.visit} <a href="https://www.scalapay.com/" rel="noreferrer" target="_blank">{modalLoc.url}</a></p>
        </div>
      </Modal>
    </div>
  );
};

export default Scalapay;
